import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import {HttpService} from '../../http/http.service';
import {stripeDefaultSettings} from './constants/stripe';
import {StripeAfterPaymentResponse, StripePaymentIntentPostResponse} from './models/stripe';
import {from, Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class StripeService {

  // @ts-ignore
  private stripeObject: stripe.Stripe;

  // @ts-ignore
  private stripeElements: stripe.elements.Elements;

  // @ts-ignore
  public stripeCardElement: stripe.elements.Element;

  constructor(private httpService: HttpService) {
  }

  initStripe(): void {

    /**
     * Had to do like this because key EDITOR doesn't pickup new key
     */
    const stripeKey = environment.appEnv !== 'production' ? environment.stripekey : 'pk_live_NmMt2oV5twW3y08lhMn26w1c';
    // @ts-ignore
    this.stripeObject = Stripe(stripeKey);
    this.stripeElements = this.stripeObject.elements();
    this.stripeCardElement = this.stripeElements.create('card', stripeDefaultSettings);
    this.stripeCardElement.mount('#card-element');
  }

  takePayment(amount: number, description: string, name: string): Observable<Observable<StripeAfterPaymentResponse>> {
    return this.paymentIntent(amount, description).pipe(map((intentResponse) => {
      return from(this.stripeObject.confirmCardPayment(
        intentResponse.client_secret,
        {
          payment_method: {
            card: this.stripeCardElement,
            billing_details: {name}
          }
        }
      )) as Observable<StripeAfterPaymentResponse>;
    }));
  }

  private paymentIntent(amount: number, description: string): Observable<StripePaymentIntentPostResponse> {
    return this.httpService.post('api/checkout/stripe/payment-intent', {
      amount,
      description
    })
      .pipe(map((data: { data: StripePaymentIntentPostResponse }) => {
        return data.data;
      }));
  }

}

